"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flyout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Toggler = require("b2b-components/core/components/Dropdown/Toggler");
var _FlyoutWindow = require("./FlyoutWindow");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Flyout = _ref => {
  let {
    className,
    dataAttributes,
    label,
    onFlyoutOpen,
    renderContent
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const togglerRef = (0, _react.useRef)(null);
  const setTogglerRef = element => togglerRef.current = element;
  const toggleFlyoutWindow = () => {
    const nextIsOpen = !isOpen;
    setIsOpen(nextIsOpen);
    nextIsOpen && onFlyoutOpen && onFlyoutOpen();
  };
  const closeFlyoutWindow = () => setIsOpen(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Toggler.Toggler, {
    label: label,
    onClick: toggleFlyoutWindow,
    styleType: _Toggler.DROPDOWN_TOGGLER_STYLE_TYPE.button,
    className: className,
    dataAttributes: dataAttributes,
    setRef: setTogglerRef
  }), isOpen && /*#__PURE__*/_react.default.createElement(_FlyoutWindow.FlyoutWindow, {
    closeFlyoutWindow: closeFlyoutWindow,
    renderContent: renderContent,
    togglerRef: togglerRef
  }));
};
exports.Flyout = Flyout;
//# sourceMappingURL=Flyout.js.map